import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from "../../components/header/header.component";
import { ShopService } from '../../../shop/services/shop.service';

@Component({
  imports: [RouterOutlet, HeaderComponent],
  templateUrl: './shared-layout.component.html',
})
export class SharedLayoutComponent {

  private shopService = inject(ShopService);

  ngOnInit() {

    this.shopService.init();
  }

}
